// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-align-left[data-v-83288122]{text-align:left}.mt-2[data-v-83288122]{margin-top:.5rem}.mt-3[data-v-83288122]{margin-top:1rem}button[data-v-83288122]:focus{color:#fff}hr[data-v-83288122]{margin-top:20px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
